import React,{useState,useEffect} from 'react'
import { Elevation, Icon,Card,Dialog,Collapse,Alert } from "@blueprintjs/core";
import { useAuthState } from 'react-firebase-hooks/auth';
import {getAuth} from 'firebase/auth'
import { doc, updateDoc, deleteDoc } from 'firebase/firestore'
import db from '../firebase/config'
const auth = getAuth()

function Label(props) {

    const [visible,setVisible] = useState(false)
    const [show,setShow] = useState(false)
    const [edit,setEdit] = useState(false)
    const [disabled,setDisabled] = useState(false)
    const [new_name,setNewName] = useState("")
    const [user] = useAuthState(auth)
    const [alert,setAlert] = useState(false)
    const [open, close] = useState(false)
    const {name, color,docId} = props.info
    const setDataNull = props.setDataNull

    useEffect(() => {
        if(new_name === "" ){setDisabled(true) } else setDisabled(false)
    },[new_name])

    const updateLabel = async ()=>{
           let docRef = doc(db, "labels",docId)
           await updateDoc(docRef,{
                name:new_name,
           })
           await setNewName("")
           await close(prev=>!prev); setVisible(prev=>!prev)
    }

    const updateColor = async (selected)=>{
        let docRef = doc(db, "labels",docId)
        await updateDoc(docRef,{
             color:selected,
        })
    }

    const deleteLabel = async ()=>{
        let docRef = doc(db, "labels",docId);
        await deleteDoc(docRef)
        await setVisible(false)
        await  setDataNull()
    }
    return (
        <div>
            <Card interactive={true} elevation={Elevation.TWO} id="card" 
                style={{backgroundColor:color}}
                >
                <div id="just-bar">
                    <p id="p">{name}</p>
                </div>
                <button id="more-button" style={{backgroundColor:color}} onClick={()=>setVisible(prev=>!prev)}>
                       <Icon icon="more"  color="#ecf1f5" />
                      </button>
            </Card>

             <Dialog isOpen={visible} style={{backgroundColor:'#30404D'}}>
                <button id="close-btn"onClick={()=>setVisible(prev=>!prev)} ><Icon icon="cross"  color="#ecf1f5" /></button>
               <div id="action-btn" onClick={()=>setEdit(prev=>!prev)}>
                        <Icon icon="edit" color="#ecf1f5" style={{marginRight:10}} /> 
                          Rename label
                    </div>     
                    <Collapse isOpen={edit}>
                      <input type="text" id="input" placeholder="Enter a new name"
                        value={new_name}
                        onChange={e=>setNewName(e.target.value)}
                         />
                        <button id="ok-update"  disabled={disabled} onClick={()=>updateLabel()}>Update</button>
                    </Collapse>

                    <div id="action-btn" onClick={()=>deleteLabel()}>
                        <Icon icon="trash" color="#ecf1f5" style={{marginRight:10}} /> 
                          Delete label
                    </div>

                    <div id="action-btn" onClick={()=>setShow(prev=>!prev)}>
                        <Icon icon="contrast" color="#ecf1f5" style={{marginRight:10}} /> 
                          Change color
                    </div>
                     
                     <Collapse isOpen={show}>
                        <div id="just-bar" style={{marginLeft:'2%'}}>
                            <div id="color-container" style={{backgroundColor:"#5C255C"}} onClick={()=>updateColor("#5C255C")}/>
                            <div id="color-container" style={{backgroundColor:"#1D7324"}} onClick={()=>updateColor("#1D7324")}/>
                            <div id="color-container" style={{backgroundColor:"#154360"}} onClick={()=>updateColor("#154360")}/>
                            <div id="color-container" style={{backgroundColor:"#F1C40F"}} onClick={()=>updateColor("#F1C40F")}/>
                            <div id="color-container" style={{backgroundColor:"#138D75"}} onClick={()=>updateColor("#138D75")}/>
                            <div id="color-container" style={{backgroundColor:"#273746"}} onClick={()=>updateColor("#273746")}/>
                            <div id="color-container" style={{backgroundColor:"#3498DB"}} onClick={()=>updateColor("#3498DB")}/>
                        </div>
                      </Collapse>

             </Dialog>

             <Alert isOpen={alert}>
                 Label deleted
             </Alert>

             <Alert isOpen={open} style={{backgroundColor:'#30404D'}}   onClose={()=>close(prev=>!prev)} canOutsideClickCancel={true}>
                    <p id="p">Label updated</p>
             </Alert>
        </div>
    )
}

export default Label
